<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="app-container">
    <div class="left-box">
      <el-menu default-active="basic-settings" class="el-menu-vertical-demo" @select="handleSelect">
        <el-menu-item index="basic-settings">
          <i class="fa fa-list-alt"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('基本设置') }}</span>
        </el-menu-item>
        <el-menu-item index="security-settings">
          <i class="fa fa-shield"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('安全设置') }}</span>
        </el-menu-item>
        <el-menu-item index="version">
          <i class="fa fa-list-alt"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('版本信息') }}</span>
        </el-menu-item>
        <el-menu-item index="upgrade-records">
          <i class="fa fa-shield"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('升级记录') }}</span>
        </el-menu-item>
        <el-menu-item v-if="showTestSpeaker" index="test-speaker">
          <i class="fa fa-list-alt"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('播报测试') }}</span>
        </el-menu-item>
        <!-- <el-menu-item index="3">
          <i class="fa fa-envelope-o"></i>
          <span slot="title" style="padding-left: 10px;">{{ $t('新消息通知') }}</span>
        </el-menu-item> -->
      </el-menu>
    </div>
    <div class="right-box">
      <div v-show="keyIndex === 'basic-settings'" class="basic-settings">
        <span class="basic-title">{{ $t('个人信息') }}</span>
        <ku-form ref="userInfo" :model="userInfo" vertical status-icon class="userInfo-ruleForm" :rules="infoRules">
          <ku-form-item :label="$t('用户名称')">
            <el-input v-model="userInfo.name" :disabled="true" />
          </ku-form-item>
          <ku-form-item :label="$t('邮箱')" prop="email">
            <el-input v-model="userInfo.email" :placeholder="userInfo.email" />
          </ku-form-item>
          <ku-form-item :label="$t('联系电话')" prop="tel">
            <el-input v-model="userInfo.tel" :placeholder="userInfo.phone" />
          </ku-form-item>
          <ku-form-item :label="$t('个人描述')">
            <el-input v-model="userInfo.workDescribe" type="textarea" :placeholder="$t('请输入内容')" :autosize="{ minRows: 4}" resize="none" maxlength="250" show-word-limit />
          </ku-form-item>
        </ku-form>

        <el-button type="primary" class="sumbit-btn" @click="updateBaseInfo">{{ $t('提 交') }}</el-button>
        <div>
          <el-image :src="userInfo.avatar" class="head-img" />
          <el-upload
            class="upload-demo"
            style="position: absolute; top: 310px; left: 817px;"
            :action="action"
            :data="imgData"
            :multiple="false"
            :headers="imgHeaders"
            :limit="2"
            list-type="picture"
            :on-success="dialogImgSuccess"
            :on-error="dialogImgFailed"
            :on-change="dialogImgChange"
            :on-remove="handleImgRemove"
            :file-list="fileList"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary" class="mt-5">{{ $t('更换头像') }}</el-button>
          </el-upload>
        </div>
      </div>

      <div v-show="keyIndex === 'security-settings'" class="security-settings">
        <span class="security-title">{{ $t('安全设置') }}</span>
        <div class="security-content">
          <div class="content-left">
            <span class="content-title">{{ $t('账户密码') }}</span>
            <!-- <span class="content-text">{{ $t('当前密码强度：强') }}</span> -->
          </div>
          <ku-button type="text" class="content-right" @click="passwordChange">
            {{ $t('修改') }}
          </ku-button>
        </div>
        <div class="security-content">
          <div class="content-left">
            <span class="content-title">{{ $t('修改密保手机') }}</span>
            <span class="content-text">{{ $t('已绑定手机：') }}<span>{{ mobile }}</span></span>
          </div>
          <ku-button type="text" class="content-right" @click="phoneChange">
            {{ $t('修改') }}
          </ku-button>
        </div>
      </div>
      <div v-show="keyIndex === 'version'" class="version" :style="note">
        <img class="transLogo" :src="transLogoUrl" />
        <div class="desc">{{ $t('纺织行业数字化整体解决方案服务商') }}</div>
        <div class="info-bottom">
          <div class="curVer">{{ $t('当前版本：') }}<span>{{ curVer }}</span></div>
          <div v-if="expirationTime" class="deadline">{{ $t('到期时间：') }}<span>{{ expirationTime }}</span></div>
          <div class="copyRight">{{ $t('版权所有©') }}<span>{{ curYear }}</span> {{ $t('佛山市技研智联科技有限公司') }}</div>
        </div>
      </div>
      <div v-show="keyIndex === 'upgrade-records'" class="upgrade-records">
        <vxe-table
          align="left"
          :data="records"
          style="width:95%;margin:0 auto"
        >
          <vxe-column field="version" :title="$t('版本号')" />
          <vxe-column field="createTime" :title="$t('升级时间')" />
        </vxe-table>
      </div>
      <div v-show="keyIndex === 'test-speaker'" style="padding: 24px; width: 40%; display: flex; flex-direction: column;">
        <ku-input v-model="speakerMsg" :placeholder="$t('请输入需要播报的内容')" />
        <ku-select v-if="speakLangList.length" v-model="speakLang" :options="speakLangList" :placeholder="$t('请输入需要播报的语言，默认zh-CN')" />
        <ku-input v-model="speakTimes" type="number" :placeholder="$t('请输入需要播报的次数，默认1')" />
        <div>{{ $t('默认播报“测试语音播报，testing message broadcast”') }}</div>
        <el-button type="primary" style="margin-top: 16px;" @click="onTestSpeakerClick">{{ $t('测试播报') }}</el-button>
        <div v-for="(msg, index) in msgList" :key="`msg-${index}`">{{ msg }}</div>
      </div>
    </div>
    <el-dialog :title="$t('修改密码')" :close-on-click-modal="false" :visible.sync="pwdDialogVisible" width="600px">
      <ku-alert show-icon type="info" :closable="false" :title="$t('修改成功后，需使用新密码重新登录系统')" />
      <ku-form ref="ruleForm" vertical label-position="right" :model="ruleForm" :rules="rules" class="order-Form">
        <ku-form-item :label="$t('原密码：')" prop="oldPassword">
          <el-input v-model="ruleForm.oldPassword" :placeholder="$t('请输入')" show-password />
        </ku-form-item>
        <ku-form-item :label="$t('新密码：')" prop="newPassword">
          <el-input v-model="ruleForm.newPassword" :style="strength === '' ? 'width:267px' : 'width:252px'" :placeholder="$t('请输入')" show-password />
          <div style="padding-left:8px">{{ $t('密码强度：') }}<span
            :style="{color:strength === $t('强')? '#52C61A'
              : '#FF4D4F'}"
          >{{ strength }}</span></div>
        </ku-form-item>
        <ku-form-item :label="$t('确认密码：')" prop="checkPass">
          <el-input v-model="ruleForm.checkPass" :placeholder="$t('请输入')" show-password />
        </ku-form-item>
      </ku-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdDialogVisible = false">{{ $t('取 消') }}</el-button>
        <el-button type="primary" @click="modifyPwd">{{ $t('确 定') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('修改手机号')" :close-on-click-modal="false" :visible.sync="editPhoneVisible" width="600px">
      <ku-alert show-icon type="info" :closable="false" :title="$t('修改成功后，需使用新手机号重新登录系统')" />
      <ku-form ref="ruleForm2" vertical :model="ruleForm2" :rules="rules2" class="order-Form">
        <ku-form-item v-show="step === '1'" :label="$t('原手机号：')" prop="curAccount">
          <el-input v-model="ruleForm2.curAccount" :placeholder="$t('请输入')" />
        </ku-form-item>
        <ku-form-item v-show="step === '1'" :label="$t('系统密码：')" prop="passWord">
          <el-input v-model="ruleForm2.passWord" :placeholder="$t('请输入当前登录密码')" show-password />
        </ku-form-item>
        <ku-form-item v-show="step === '2'" :label="$t('新手机号：')" prop="newAccount">
          <el-input v-model="ruleForm2.newAccount" :placeholder="$t('请输入')" />
        </ku-form-item>
        <ku-form-item v-show="step === '2'" :label="$t('短信验证码：')" prop="smsCode">
          <el-input v-model="ruleForm2.smsCode" style="width:225px" :placeholder="$t('请输入短信验证码')" />
          <div style="padding-left:8px">
            <el-button style="margin-right:0px;width: 112px;" @click="getSmsCode">{{ smsText }}</el-button>
          </div>
        </ku-form-item>
      </ku-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="step === '1'" type="primary" @click="nextStep">{{ $t('下一步') }}</el-button>
        <el-button v-show="step === '2'" @click="editPhoneVisible = false">{{ $t('取 消') }}</el-button>
        <el-button v-show="step === '2'" type="primary" @click="modifyAccount">{{ $t('确 定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from '@klinx/utils/localstorage';
import { baseAuthorityApi, baseTenantApi } from '@klinx/base/src/api/index.js';
var phone = /^([0-9][0-9][0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
var tels = /^d{8}$|^0\d{2,3}-?\d{7,8}$/;
var email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
// 是否包含一位数字
const regNumber = /(?=.*[\d])/;
// 是否包含一位字母
const regLetter = /(?=.*[a-zA-Z])/;
// 是否包含一位特殊字符
const regCharacter = /(?=.*[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、])/;
let interval = null;
export default {
  filters: {
    stateFilter(status) {
      return status ? 'success' : 'info';
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('新密码不能为空！请重新输入')));
        return;
      }
      if (value.length > 13) {
        callback(new Error(this.$t('密码长度不超过13个字符')));
        return;
      }
      if (value.length < 6) {
        callback(new Error(this.$t('密码长度不低于6个字符')));
        return;
      }
      if (regCharacter.test(value)) {
        callback(new Error(this.$t('密码不支持特殊符号，请输入6-13位数字和字母')));
        return;
      }
      if (!(regNumber.test(value) && regLetter.test(value))) {
        callback(new Error(this.$t('该密码过于简单，请输入6-13位数字和字母')));
        return;
      }
      callback();
    };
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请再次输入密码')));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error(this.$t('两次输入密码不一致!')));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value) {
        if (email.test(value) === false) {
          callback(new Error(this.$t('必须输入标准邮箱格式')));
        }
      } else {
        callback();
      }
      callback();
    };
    var validateTels = (rule, value, callback) => {
      if (value) {
        if (tels.test(value) === false) {
          callback(new Error(this.$t('请输入正确的电话号码格式')));
        }
      } else {
        callback();
      }
      callback();
    };
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入新手机号')));
      } else {
        if (phone.test(value) === false) {
          callback(new Error(this.$t('请输入11位手机号码')));
          this.canSendMsg = false;
        } else {
          this.canSendMsg = true;
        }
        callback();
      }
    };
    return {
      transLogoUrl: require("../../assets/logo-transparent.png"),
      note: {
        backgroundImage: "url(" + require("../../assets/system-bg.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundPosition: 'center'
      },
      loading: false,
      hasTenantVersion: false,
      curYear: '',
      curVer: '',
      klinxImg: '',
      records: [],
      fullscreenLoading: false,
      fileList: [],
      action: `${process.env.VUE_APP_BASE_API}/base/attachment/upload`,
      imgData: {
        bizId: 0,
        bizType: 0,
        isSingle: 0,
        id: 0
      },
      imgHeaders: {
        token: 'Bearer ' + db.get('TOKEN', '')
      },
      currentTime: 60,
      smsText: this.$t('获取验证码'),
      infoRules: {
        email: [{ required: false, validator: validateEmail, trigger: 'blur' }],
        tel: [{ required: false, validator: validateTels, trigger: 'blur' }]
      },
      keyIndex: 'basic-settings',
      editPhoneVisible: false,
      pwdDialogVisible: false,
      rules: {
        oldPassword: [
          { required: true, message: this.$t('请输入原密码'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validateCheckPass, trigger: 'blur' }
        ]
      },
      rules2: {
        curAccount: [
          { required: true, message: this.$t('请输入原手机号'), trigger: 'blur' }
        ],
        passWord: [
          { required: true, message: this.$t('请输入当前登录密码'), trigger: 'blur' }
        ],
        newAccount: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: this.$t('请输入短信验证码'), trigger: 'blur' }
        ]
      },
      ruleForm2: {
        curAccount: '',
        passWord: '',
        newAccount: '',
        smsCode: ''
      },
      ruleForm: {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      },
      userInfo: {
        name: '',
        email: '',
        tel: '',
        workDescribe: '',
        avatar: ''
      },
      lastAvatar: '',
      strength: '',
      step: '1',
      mobile: '',
      canSendMsg: false,
      expirationTime: '', // 到期时间
      speakerMsg: '',
      speakLang: 'zh-CN',
      speakLangList: [],
      speakTimes: 1
    };
  },
  computed: {
    showTestSpeaker() {
      return !!localStorage.getItem('testSpeaker');
    },
    msgList() {
      return this.$store.state.account.speakMsgList;
    }
  },
  watch: {
    ruleForm: {
      handler(val) {
        if (!val.newPassword) {
          return;
        }

        this.strength = regLetter.test(val.newPassword) && regNumber.test(val.newPassword) ? this.$t('强') : this.$t('弱');
      },
      deep: true
    },
    pwdDialogVisible(val) {
      if (!val) {
        this.ruleForm = {
          oldPassword: '',
          newPassword: '',
          checkPass: ''
        };
        this.$refs.ruleForm.$children[0].clearValidate();
      }
    },
    editPhoneVisible(val) {
      if (!val) {
        this.ruleForm2 = {
          curAccount: '',
          passWord: '',
          newAccount: '',
          smsCode: ''
        };
        this.$refs.ruleForm2.$children[0].clearValidate();
        this.step = '1';
        clearInterval(interval);
        this.smsText = this.$t('获取验证码');
        this.currentTime = 60;
      }
    },
    'userInfo.avatar': {
      handler(newAvatar) {
        if (newAvatar) {
          this.lastAvatar = newAvatar;
        }
      },
      immediate: true
    }
  },
  created() {
    this.fetch();
  },
  mounted() {
    !!localStorage.getItem('testSpeaker') && setTimeout(() => {
      (this.speakLangList = window.speechSynthesis.getVoices().reduce((pre, item) => {
        if (!pre.some(v => v.value === item.lang)) {
          pre.push({ label: item.lang, value: item.lang });
        }
        return pre;
      }, []));
    }, 500);
  },
  methods: {
    onTestSpeakerClick() {
      this.$eventBus.$emit('testSpeaker', this.speakerMsg || this.$t('测试语音播报，testing message broadcast'), '', this.speakTimes, this.speakLang, '');
    },
    // 获取到期时间
    getLimitTime() {
      baseTenantApi.getInfo().then(res => {
        if (res?.data?.isSuccess) {
          const expirationTime = res.data.data.expirationTime;
          this.expirationTime = expirationTime ? expirationTime.slice(0, -8) + this.$t('\(剩余') + (this.restTime(expirationTime) < 0 ? 0 : this.restTime(expirationTime)) + this.$t('天\)') : '';
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 计算剩余天数
    restTime(date) {
      return parseInt((new Date(date).getTime() - new Date().getTime()) / (60 * 60 * 24 * 1000));
    },
    // 更换头像
    beforeUpload(file) {
      let isImgOk = true;
      if (!['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)) {
        this.$message.error(this.$t('不支持该格式，无法上传'));
        isImgOk = false;
      } else if (file.size > 1024 * 1000) {
        this.$message.error(this.$t('上传图片大小不能超过[size]M').replace('[size]', 1));
        isImgOk = false;
      }

      if (!isImgOk) {
        return false;
      }

      this.fullscreenLoading = true;
    },
    handleImgRemove(data) { // 移除钩子
      this.userInfo.avatar = this.lastAvatar || '';
    },
    dialogImgSuccess(data) { // 上传图片成功
      this.userInfo.avatar = data.data.url.split('?')[0];
      this.fullscreenLoading = false;
    },
    dialogImgFailed() {
      this.fullscreenLoading = false;
    },
    dialogImgChange(file, fileList) { // 上传图片的钩子
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择文件
      }
    },
    // 修改账号
    modifyAccount() {
      this.$refs.ruleForm2.$children[0].validate((valid) => {
        if (valid) {
          const data = {
            newAccount: this.ruleForm2.newAccount,
            smsCode: this.ruleForm2.smsCode
          };
          baseTenantApi.modifyAccount(data).then(resp => {
            const res = resp.data;
            if (res.isSuccess) {
              this.fetch();
              this.editPhoneVisible = false;
              this.$message.success(this.$t('修改成功'));
            } else {
              this.$message.error(res.msg);
            }
          }).catch(() => {

          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取短信验证码
    getSmsCode() {
      if (this.canSendMsg) {
        const data = {
          account: this.ruleForm2.newAccount
        };
        baseTenantApi.getSmsCode(data).then(resp => {
          const res = resp.data;
          if (res.isSuccess) {
            if (res.msg === this.$t('新账号已存在')) {
              return;
            } else {
              this.$message.success(this.$t('验证码发送成功，请注意接收'));
              interval = setInterval(() => {
                this.currentTime--;
                this.smsText = this.currentTime + this.$t('秒');
                if (this.currentTime <= 0) {
                  clearInterval(interval);
                  this.smsText = this.$t('重新发送');
                  this.currentTime = 60;
                }
              }, 1000);
            }
          } else {
            this.$message.error(res.msg);
          }
        }).catch(() => {

        });
      } else {
        this.$message.warning(this.$t('请输入格式正确的手机号码'));
      }
    },
    // 获取基本信息
    fetch(params = {}) {
      baseAuthorityApi.getBaseInfo(params).then(resp => {
        console.log(this.$t('获取基本信息'), resp.data);
        const res = resp.data;
        this.userInfo = res.data;
        this.mobile = res.data.mobile;
        console.log(this.userInfo);
      }).catch(() => {

      });
      if (!this.hasTenantVersion) {
        this.hasTenantVersion = true;
        this.curYear = new Date().getFullYear();
        baseTenantApi.getVersion().then(res => {
          if (res.data.isSuccess) {
            this.curVer = res.data.data;
          }
        });
      }

      baseTenantApi.versionRecords().then(res => {
        if (res.data.isSuccess) {
          this.records = res.data.data;
        }
      });

      this.getLimitTime();
    },
    // 修改基本信息
    updateBaseInfo() {
      this.$refs.userInfo.$children[0].validate((valid) => {
        if (valid) {
          console.log(this.$t('修改基本信息'), this.userInfo);
          baseAuthorityApi.updateBaseInfo(this.userInfo).then(resp => {
            const res = resp.data;
            if (res.isSuccess) {
              this.fetch();
              this.$message.success(this.$t('修改成功'));
            } else {
              this.$message.error(res.msg);
            }
          }).catch(() => {

          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 改密码
    modifyPwd() {
      this.$refs.ruleForm.$children[0].validate((valid) => {
        if (valid) {
          baseTenantApi.modifyPassword(this.ruleForm).then(resp => {
            const res = resp.data;
            if (res.isSuccess) {
              this.fetch();
              this.pwdDialogVisible = false;
              this.$message.success(this.$t('修改成功'));
            } else {
              this.$message.error(res.msg);
            }
          }).catch(() => {

          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 验证当前登录账号密码 并 下一步
    nextStep() {
      if (this.ruleForm2.curAccount !== '' && this.ruleForm2.passWord !== '') {
        const data = {
          curAccount: this.ruleForm2.curAccount,
          password: this.ruleForm2.passWord
        };
        baseTenantApi.checkCurAccountPassword(data).then(resp => {
          const res = resp.data;
          if (res.isSuccess) {
            this.step = '2';
          } else {
            this.$message.error(res.msg);
          }
        }).catch(() => {

        });
      } else {
        console.log('error submit!!');
        return false;
      }
    },
    // 改手机弹窗
    phoneChange() {
      this.editPhoneVisible = true;
    },
    // 改密码弹窗
    passwordChange() {
      this.pwdDialogVisible = true;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.keyIndex = key;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .userInfo-ruleForm {
  margin-top: 40px;
  // .el-form-item {
  .el-form-item__label {
    text-align: left;
    vertical-align: middle;
    float: none;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    padding: 0 0 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .el-input__suffix {
    display: none;
    right: 5px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    pointer-events: none;
  }
}
::v-deep .order-Form {
  margin-top: 24px;
  .el-form-item {
    display: flex;
    justify-content: flex-end;
    label {
      font-weight: 400;
    }
    .el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      padding: 0 0 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .el-form-item__content {
      position: relative;
      font-size: 14px;
      display: flex;
      .el-input {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 345px;
        height: 32px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-upload-list {
  display: none !important;
}
::v-deep .el-icon-warning:before {
  content: "\E7A3";
  color: #597ef7;
}
::v-deep .el-dialog__header {
  padding: 20px;
  padding-bottom: 10px;
  // border-bottom: 1px solid #f0f0f0;
}
::v-deep .el-dialog__body {
  padding: 16px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
::v-deep .el-dialog__footer {
  // border-top: 1px solid #f0f0f0;
  padding: 10px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-menu {
  width: 218px;
  list-style: none;
  border-right: solid 0px #e6e6e6;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: #fff;
}
::v-deep .el-menu-item i {
  color: #000000;
}
::v-deep .el-menu-item.is-active i {
  color: #ffffff;
}
::v-deep .el-menu-item.is-active {
  color: #ffffff;
  background-color: #ff6900;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}
::v-deep .el-menu-item:hover,
.el-menu-item:focus {
  outline: none;
  background-color: #ff6900;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}
.app-container {
  height: 97%;
  background: #ffffff;
  display: flex;
  justify-content: start;
  .left-box {
    width: 250px;
    height: 100%;
    opacity: 1;
    background: #ffffff;
    // box-shadow: -1px 0px 0px 0px #f0f0f0 inset;
  }
  .right-box {
    margin-left: 16px;
    border-left: 1px solid #f0f0f0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    .version{
      text-align: center;
      width:100%;
      height:inherit;
      position: relative;
      .transLogo{
        position: absolute;
        top:50%;
        left:50%;
        transform: translate(-50%,-50%);
      }
      .desc{
        position: absolute;
        color:#86909C;
        font-size:20px;
        top:56%;
        left:50%;
        transform: translate(-50%,0);
        margin-top: 16px;
      }
      .info-bottom {
        position: absolute;
        bottom:5%;
        left:50%;
        transform: translate(-50%,0);
        .curVer{
          color:#4E5969;
          font-size:16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .deadline{
          color:#4E5969;
          font-size:16px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .copyRight{
          color:#4E5969;
          font-size:14px;
        }
      }
    }
    .basic-settings {
      padding: 16px 32px 16px 32px;
      display: flex;
      flex-direction: column;
      .el-input {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 395px;
        padding-top: 8px;
        // padding-bottom: 8px;
      }
      .el-textarea {
        width: 395px;
        // position: relative;
        // padding-top: 8px;
        // display: inline-block;
        // vertical-align: bottom;
        // font-size: 14px;
      }
      .basic-title {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
      }
      .sumbit-btn {
        margin-top: 8px;
        width: 75px;
        opacity: 1;
        border-radius: 2px;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04);
      }
      .head-img {
        position: absolute;
        top: 190px;
        left: 786px;
        width: 144px;
        height: 144px;
        border-radius: 50%;
        border: 1px solid rgba(0, 0, 0, 0.15);
      }
      .head-btn {
        width: 110px;
        position: absolute;
        left: 803px;
        top: 350px;
      }
    }

    .security-settings {
      padding: 16px 32px 16px 32px;
      display: flex;
      flex-direction: column;
      .security-title {
        padding-bottom: 56px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: left;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
      }
      .security-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 886px;
        padding-bottom: 22px;
        margin-bottom: 24px;
        border-bottom: solid 1px #f0f0f0;
        .content-left {
          display: flex;
          flex-direction: column;
          .content-title {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
          }
          .content-text {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            text-align: LEFT;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
          }
        }
      }
    }
  }
}

  ::v-deep .el-menu-item.is-active{
    background:#3A71FF !important;
  }

  ::v-deep .el-menu-item:hover{
    background:#3A71FF !important;
    .fa{
      color:white !important;
    }
    color:white !important;
  }
</style>
